import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogConfig, KalDialogRef, KalDialogService } from '@kalidea/kaligraphi';
import { MailService } from 'src/app/_core/services/mail.service';
import { FormControl } from '@angular/forms';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
    SharedMailComponent,
} from 'src/app/_shared/components/mail/shared-mail/shared-mail.component';
import { MailParameters } from 'src/app/_shared/components/mail/shared-mail-container/shared-mail-container.component';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/_shared/dialogs/confirm-dialog/confirm-dialog.component';
import { arrayNotEmpty } from 'src/app/utils/array.utils';

export interface SharedMailDialogData {
    mailParameters: MailParameters[];
}

@Component({
    selector: 'app-shared-mail-dialog',
    templateUrl: './shared-mail-dialog.component.html',
    styleUrls: ['./shared-mail-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedMailDialogComponent extends BaseComponent {

    formControl = new FormControl(null, [SharedMailComponent.Validator]);

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly dialogRef: KalDialogRef<SharedMailDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedMailDialogData,
                private readonly mailService: MailService,
                private readonly dialogService: KalDialogService) {
        super(cdr);
    }

    get mailParameters(): MailParameters[] {
        return this.data?.mailParameters || null;
    }

    get isMultiple(): boolean {
        return this.mailParameters?.length > 1;
    }

    get loading$(): Observable<boolean> {
        return this.mailService.loading$;
    }

    close(): void {
        this.dialogRef.close();
    }

    sendMail(): void {
        const mail = this.formControl.value;
        const idsList = this.mailParameters[0]?.idsList || [];
        const generatedDocumentsList = this.mailParameters[0]?.generatedDocumentsList || [];

        const docs = [...(mail?.reportsDocumentsList ?? []), ...(mail?.generatedDocumentsList ?? [])];
        const vouchers = mail?.vouchersList ?? [];
        const hasReportOptions = arrayNotEmpty(docs);
        const hasSelectedReport = docs.some(d => !!d?.selected);
        const hasVoucher = arrayNotEmpty(vouchers);

        if (hasReportOptions && !hasSelectedReport && !hasVoucher) {
            const config = new KalDialogConfig<ConfirmDialogData>({
                backdropClass: 'cdk-overlay-dark-backdrop',
                hasBackdrop: true,
                data: {
                    body: 'Aucun document sélectionné ; le mail sera envoyé sans pièce jointe. Continuer ?',
                    submitLabel: 'Envoyer',
                    cancelLabel: 'Annuler'
                }
            });

            this.watch$ = this.dialogService
                .open(ConfirmDialogComponent, config)
                .afterClosed
                .pipe(
                    filter(result => !!result?.accepted),
                    switchMap(() =>
                        this.mailService
                            .sendPublipostageMail({ mail, idsList, generatedDocumentsList })
                            .pipe(tap(() => this.close()))
                    )
                );

        } else {
            this.watch$ = this.mailService
                .sendPublipostageMail({ mail, idsList, generatedDocumentsList })
                .pipe(tap(() => this.close()));
        }
    }
}
